<template>
  <div v-loading="pageLoading">
    <div>
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="章節名稱" class="gold_item_label">
          <el-input
            v-model="form.sectionName"
            placeholder="請輸入章節名稱"
            type="textarea"
            :rows="3"
            style="width: 300px"
            maxlength="100"
            show-word-limit
          ></el-input>
        </el-form-item>
        <el-form-item label="章節簡介" class="gold_item_label">
          <el-input
            type="textarea"
            :rows="2"
            style="width: 600px"
            maxlength="500"
            show-word-limit
            v-model="form.intro"
            placeholder="請輸入章節簡介"
          ></el-input>
        </el-form-item>

        <el-form-item label="章節教材" prop="rul" v-if="courseType == 'online'">
          <!-- 圖片 -->
          <el-upload
            class="upload-demo"
            action=""
            accept=".jpg,.png,.gif"
            :on-remove="handleRemove1"
            :file-list="fileList1"
            :auto-upload="false"
            list-type="picture-card"
            :on-change="changeFile1"
            multiple
            v-if="fileList2.length == 0 && fileList3.length == 0"
          >
            <i class="el-icon-plus"></i>
            <div slot="tip" class="el-upload__tip">
              建議圖片尺寸：1130px (闊)
            </div>
          </el-upload>
          <!-- 分界线 -->
          <div style="margin: 20px 0"></div>
          <!-- 視頻 -->
          <el-upload
            class="upload-demo"
            action=""
            accept=".MP4,.AVI"
            :on-remove="handleRemove2"
            :file-list="fileList2"
            :auto-upload="false"
            list-type="text"
            :on-change="changeFile2"
            :limit="1"
            :on-exceed="exceed"
            v-if="fileList1.length == 0 && fileList3.length == 0"
          >
            <el-button slot="trigger" size="small" type="primary"
              >上傳視頻</el-button
            >
          </el-upload>
          <!-- 分界线 -->
          <div style="margin: 20px 0"></div>
          <!-- PDF -->
          <el-upload
            class="upload-demo"
            action=""
            accept=".pdf"
            :on-remove="handleRemove3"
            :file-list="fileList3"
            :auto-upload="false"
            :on-change="changeFile3"
            list-type="text"
            :limit="1"
            :on-exceed="exceed"
            v-if="fileList1.length == 0 && fileList2.length == 0"
          >
            <el-button size="small" type="primary">上傳PDF</el-button>
          </el-upload>

          <!-- 分界线 -->
          <div style="margin: 20px 0"></div>
        </el-form-item>

        <!-- <el-form-item label="圖片"
                      prop="picture_file"
                      v-show="courseType == 'online'"
                      v-if="fileList2.length == 0 && fileList3.length == 0">
          <el-upload class="upload-demo"
                     action=""
                     accept=".jpg,.png,.gif"
                     :on-remove="handleRemove1"
                     :file-list="fileList1"
                     :auto-upload="false"
                     list-type="picture-card"
                     :on-change="changeFile1"
                     multiple>
            <i class="el-icon-plus"></i>
            <div slot="tip"
                 class="el-upload__tip">建議圖片尺寸：1130px (闊)</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="視頻"
                      prop="video_file"
                      v-show="courseType == 'online'"
                      v-if="fileList1.length == 0 && fileList3.length == 0">
          <el-upload class="upload-demo"
                     action=""
                     accept=".MP4,.AVI"
                     :on-remove="handleRemove2"
                     :file-list="fileList2"
                     :auto-upload="false"
                     list-type="text"
                     :on-change="changeFile2"
                     :limit="1"
                     :on-exceed="exceed">
            <el-button size="small"
                       type="primary">點擊上傳</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="文件"
                      prop="content_file"
                      v-show="courseType == 'online'"
                      v-if="fileList2.length == 0 && fileList1.length == 0">
          <el-upload class="upload-demo"
                     action=""
                     accept=".pdf"
                     :on-remove="handleRemove3"
                     :file-list="fileList3"
                     :auto-upload="false"
                     :on-change="changeFile3"
                     list-type="text"
                     :limit="1"
                     :on-exceed="exceed">
            <el-button size="small"
                       type="primary">點擊上傳</el-button>
          </el-upload>
        </el-form-item> -->
        <el-form-item label="直播時間" v-show="courseType == 'live'">
          <el-date-picker
            :picker-options="pickerOptions"
            format="yyyy-MM-dd HH:mm"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="請輸入直播時間"
            v-model="time"
            type="datetime"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="新增課程測驗">
          <el-button
            v-if="questionId == ''"
            @click="questionSet"
            style="font-size: 30px"
            icon="el-icon-plus"
          ></el-button>
          <span v-else>
            <span style="padding: 0 10px">{{ questionName }}</span>
            <el-button
              type="warning"
              icon="el-icon-edit"
              circle
              @click="editQue"
            ></el-button>
          </span>
        </el-form-item>
        <el-form-item label="添加課程意見">
          <el-button
            v-if="assessmentId == ''"
            @click="assessmentSet"
            style="font-size: 30px"
            icon="el-icon-plus"
          ></el-button>
          <span v-else>
            <span style="padding: 0 10px">{{ assessmentName }}</span>
            <el-button
              type="warning"
              icon="el-icon-edit"
              circle
              @click="editAss"
            ></el-button>
          </span>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">保存</el-button>
          <el-button @click="back">取消</el-button>
        </el-form-item>
      </el-form>
      <el-button class="btn" @click="back">返 回</el-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    var checkImg = (rule, value, callback) => {
      console.log("this.form.picture_file", this.form.picture_file);
      if (
        this.form.picture_file ||
        this.form.video_file ||
        this.form.content_file
      ) {
        callback();
      } else {
        callback(new Error("圖片、視頻或者PDF，至少上傳一樣"));
      }
    };
    return {
      pageLoading: false,

      pickerOptions: {
        // 時間限制
        disabledDate(time) {
          return time.getTime() <= Date.now() - 3600 * 1000 * 24;
        },
      },
      form: {
        sectionName: "",
        intro: "",
        picture_file: "",
        video_file: "",
        content_file: "",
      },
      rules: {
        rul: [{ validator: checkImg, trigger: "change" }],
      },
      fileList1: [],
      fileList2: [],
      fileList3: [],
      questionId: "",
      questionName: "",
      assessmentId: "",
      assessmentName: "",
      courseType: "",
      time: null,
      id: "",
      prompt: false, //提示
    };
  },
  methods: {
    handleRemove1(file, fileList) {
      //文件刪除
      this.form.picture_file = "";
      this.fileList1 = fileList;
      this.$refs.form.validateField("rul");
    },
    handleRemove2(file, fileList) {
      //文件刪除
      this.form.video_file = "";
      this.fileList2 = fileList;
      this.$refs.form.validateField("rul");
    },
    handleRemove3(file, fileList) {
      //文件刪除
      this.form.content_file = "";
      this.fileList3 = fileList;
      this.$refs.form.validateField("rul");
    },
    changeFile1(file, fileList) {
      this.fileList1 = fileList;
      this.form.picture_file = this.fileList1;
      this.$refs.form.validateField("rul");
    },
    changeFile2(file, fileList) {
      this.fileList2 = fileList;
      this.form.video_file = this.fileList2;
      this.$refs.form.validateField("rul");
    },
    changeFile3(file, fileList) {
      this.fileList3 = fileList;
      this.form.content_file = this.fileList3;
      this.$refs.form.validateField("rul");
    },
    exceed() {
      this.$message({
        type: "warning",
        message: "該類型只能上傳一個!",
      });
    },
    back() {
      console.log(this.prompt);
      if (
        (this.form.sectionName ||
          this.form.intro ||
          this.fileList1.length > 0 ||
          this.fileList2.length > 0 ||
          this.fileList3.length > 0 ||
          this.time) &&
        !this.prompt
      ) {
        this.$confirm("資料尚未儲存，確定離開?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.affirmBack();
          })
          .catch(() => {});
      } else if (this.prompt) {
        this.affirmBack();
      } else {
        this.affirmBack();
      }
    },
    affirmBack() {
      sessionStorage.removeItem("questionMsg");
      sessionStorage.removeItem("assessmentMsg");
      this.$emit("back");
    },
    onSubmit() {
      let id = sessionStorage.getItem("editSection");
      var form = this.form;
      let formData = new FormData();

      var fileList1 = this.fileList1;
      var fileList2 = this.fileList2;
      var fileList3 = this.fileList3;
      if (id) {
        // 编辑新增
        let msg = {};
        if (form.sectionName == "") {
          this.$message({
            type: "warning",
            message: "請新增章節名稱",
          });
          return;
        }
        msg["sectionName"] = form.sectionName;
        formData.append("state", 0);
        msg["state"] = 0;
        formData.append("sectionName", form.sectionName);
        if (form.intro == "") {
          this.$message({
            type: "warning",
            message: "請新增章節簡介",
          });
          return;
        }
        msg["intro"] = form.intro;
        formData.append("intro", form.intro);
        msg["id"] = id;

        if (this.assessmentId) {
          formData.append(
            "manOnlineUeviomsIds",
            "[" + this.assessmentId + "]"
          )
          msg['manOnlineUeviomsIds'] = "[" + this.assessmentId + "]"
        }
        if (this.questionId) {
          formData.append(
            "manOnlineTestingIds",
            "[" + this.questionId + "]"
          )
          msg['manOnlineTestingIds'] = "[" + this.questionId + "]"
        }
        this.$refs.form.validate((valid) => {
          if (valid) {
            if (this.courseType == "online") {
              // 線上
              if (fileList1.length > 0) {
                let arr = [];
                for (let i = 0; i < fileList1.length; i++) {
                  if (fileList1[i].raw) {
                    formData.append("file", fileList1[i].raw);
                  } else {
                    arr.push(fileList1[i].url);
                  }
                }
                if (arr.length > 0) {
                  formData.append("pictureFileUrl", "[" + arr.toString() + "]");
                }
              }
              if (fileList2.length > 0) {
                if (fileList2[0].raw) {
                  formData.append("file", fileList2[0].raw);
                } else {
                  formData.append("videoFileUrl", "[" + fileList2[0].url + "]");
                }
              }
              if (fileList3.length > 0) {
                if (fileList3[0].raw) {
                  formData.append("file", fileList3[0].raw);
                } else {
                  formData.append(
                    "contentFileUrl",
                    "[" + fileList3[0].url + "]"
                  );
                }
              }
              this.$LoadingTitle = "正在上傳，請稍等……";
              formData.append("id", id);
              this.pageLoading = true
              this.axios
                .post("/manage/updateManOnlineSection", formData, {
                  headers: { "content-type": "multipart/form-data" },
                })
                .then((res) => {
                  if (res) {
                    this.$message({
                      type: "success",
                      message: "修改成功!",
                    });
                    sessionStorage.removeItem("editSection");
                    this.prompt = true;
                    this.back();
                  } else {
                    this.pageLoading = false
                  }
                }).catch(() => {
                  this.pageLoading = false
                })
            } else if (this.courseType == "offline") {
              this.$LoadingTitle = "正在上傳，請稍等……";
              this.pageLoading = true
              this.axios({
                method: "post",
                params: msg,
                url: "/manage/updateManOfflineSection",
              }).then((res) => {
                if (res) {
                  this.$message({
                    type: "success",
                    message: "修改成功!",
                  });
                  sessionStorage.removeItem("editSection");
                  this.prompt = true;
                  this.back();
                } else {
                  this.pageLoading = false
                }
              }).catch(() => {
                this.pageLoading = false
              })
            } else if (this.courseType == "live") {
              this.$LoadingTitle = "正在上傳，請稍等……";
              msg["liveTime"] = this.time;
              this.pageLoading = true
              this.axios({
                method: "post",
                params: msg,
                url: "/manage/updateManLiveSection",
              }).then((res) => {
                if (res) {
                  this.$message({
                    type: "success",
                    message: "修改成功!",
                  });
                  sessionStorage.removeItem("editSection");
                  this.prompt = true;
                  this.back();
                } else {
                  this.pageLoading = false
                }
              }).catch(() => {
                this.pageLoading = false
              })
            }
          } else {
            this.$message({
              type: "warning",
              message: "必須選擇上傳圖片、視頻或文件其中一項為此章節教材!",
            });
            console.log("error submit!!");
            return false;
          }
        });
      } else {
        let offlineMsg = {};
        let liveMsg = {};
        if (form.sectionName == "") {
          this.$message({
            type: "warning",
            message: "請新增章節名稱",
          });
          return;
        }
        formData.append("sectionName", form.sectionName);
        offlineMsg["sectionName"] = form.sectionName;
        liveMsg["sectionName"] = form.sectionName;
        if (form.intro == "") {
          this.$message({
            type: "warning",
            message: "請新增章節簡介",
          });
          return;
        }
        formData.append("intro", form.intro);
        offlineMsg["intro"] = form.intro;
        liveMsg["intro"] = form.intro;
        // if (this.questionId == '') {
        // 	this.$message({
        // 		type: 'warning',
        // 		message: '請新增課程測驗'
        // 	});
        // 	return;
        // }

        // if (this.assessmentId == '') {
        // 	this.$message({
        // 		type: 'warning',
        // 		message: '請新增反饋'
        // 	});
        // 	return;
        // }
        if (fileList1.length > 0) {
          for (let i = 0; i < fileList1.length; i++) {
            formData.append("file", fileList1[i].raw);
          }
        }
        if (fileList2.length > 0) {
          for (let i = 0; i < fileList2.length; i++) {
            formData.append("file", fileList2[i].raw);
          }
        }
        if (fileList3.length > 0) {
          for (let i = 0; i < fileList3.length; i++) {
            formData.append("file", fileList3[i].raw);
          }
        }
        let url = "";
        this.$refs.form.validate((valid) => {
          if (valid) {
            if (this.courseType == "online") {
              // 線上
              this.$LoadingTitle = "正在上傳，請稍等……";
              formData.append(
                "manOnlineUeviomsIds",
                "[" + this.assessmentId + "]"
              );
              formData.append(
                "manOnlineTestingIds",
                "[" + this.questionId + "]"
              );
              url = "/manage/addManOnlineSection";
              this.pageLoading = true
              this.axios
                .post(url, formData, {
                  headers: { "content-type": "multipart/form-data" },
                })
                .then((res) => {
                  if (res) {
                    this.$message({
                      type: "success",
                      message: "新增成功!",
                    });
                    sessionStorage.sectionMsg = JSON.stringify({
                      id: res.message,
                      name: form.sectionName,
                      intro: form.intro,
                    });
                    this.prompt = true;
                    this.back();
                  } else {
                    this.pageLoading = false
                  }
                }).catch(() => {
                  this.pageLoading = false
                })
            } else if (this.courseType == "offline") {
              this.$LoadingTitle = "正在上傳，請稍等……";

              formData.append(
                "manOfflineUeviomsIds",
                "[" + this.assessmentId + "]"
              );
              formData.append(
                "manOfflineTestingIds",
                "[" + this.questionId + "]"
              );

              // offlineMsg["manOfflineTestingIds"] = "[" + this.questionId + "]";
              // offlineMsg["manOfflineUeviomsIds"] =
              //   "[" + this.assessmentId + "]";
              url = "/manage/addManOfflineSection";
              this.pageLoading = true
              this.axios
                .post(url, formData, {
                  headers: { "content-type": "multipart/form-data" },
                })
                .then((res) => {
                  if (res) {
                    this.$message({
                      type: "success",
                      message: "新增成功!",
                    });
                    sessionStorage.sectionMsg = JSON.stringify({
                      id: res.message,
                      name: form.sectionName,
                      intro: form.intro,
                    });
                    this.prompt = true;
                    this.back();
                  } else {
                    this.pageLoading = false
                  }
                }).catch(() => {
                  this.pageLoading = false
                })
            } else if (this.courseType == "live") {
              this.$LoadingTitle = "正在上傳，請稍等……";
              if (!this.time) {
                this.$message({
                  type: "warning",
                  message: "請選擇直播時間",
                });
                return;
              }
              liveMsg["liveTime"] = this.time;
              liveMsg["manLiveTestingIds"] = "[" + this.questionId + "]";
              liveMsg["manLiveUeviomsIds"] = "[" + this.assessmentId + "]";
              this.pageLoading = true
              this.axios
                .post("/manage/addManLiveSection", this.qs.stringify(liveMsg))
                .then((res) => {
                  if (res) {
                    this.$message({
                      type: "success",
                      message: "新增成功!",
                    });
                    sessionStorage.sectionMsg = JSON.stringify({
                      id: res.message,
                      name: form.sectionName,
                      intro: form.intro,
                    });
                    this.prompt = true;
                    this.back();
                  } else {
                    this.pageLoading = false
                  }
                }).catch(() => {
                  this.pageLoading = false
                })
            }
          } else {
            this.$message({
              type: "warning",
              message: "必須選擇上傳圖片、視頻或文件其中一項為此章節教材!",
            });
            console.log("error submit!!");
            return false;
          }
        });
      }
    },
    questionSet() {
      sessionStorage.removeItem("questionSet");
      this.$emit("add-page", "question");
    },
    assessmentSet() {
      sessionStorage.removeItem("assessmentSet");
      this.$emit("add-page", "assessment");
    },
    editQue() {
      sessionStorage.setItem(
        "questionSet",
        JSON.stringify({
          id: this.questionId,
          name: this.questionName,
        })
      );
      this.$emit("add-page", "question");
    },
    editAss() {
      sessionStorage.setItem(
        "assessmentSet",
        JSON.stringify({
          id: this.assessmentId,
          name: this.assessmentName,
        })
      );
      this.$emit("add-page", "assessment");
    },
    changePage() {
      var questionMsg = sessionStorage.getItem("questionMsg");
      var assessmentMsg = sessionStorage.getItem("assessmentMsg");
      $("#pageHead").text("新增章節");
      if (questionMsg) {
        let msg = JSON.parse(questionMsg);
        this.questionId = msg.id
        this.questionName = msg.name
      }
      if (assessmentMsg) {
        let msg = JSON.parse(assessmentMsg);
        this.assessmentId = msg.id
        this.assessmentName = msg.name
      }
    },
  },
  created() {
    this.courseType = sessionStorage.getItem("courseType");
    let id = sessionStorage.getItem("editSection");
    if (id) {
      this.id = id;
      let type = 0;
      if (this.courseType == "offline") {
        type = 2;
      } else if (this.courseType == "online") {
        type = 1;
      } else if (this.courseType == "live") {
        type = 3;
      }
      this.pageLoading = true
      this.axios({
        url: "/manage/getEchoChapter",
        params: {
          id,
          type,
        },
      }).then((res) => {
        let msg = res.result;
        if (type == 1) {
          var pic = msg.picture_file.split(",");
          for (var i = 0; i < pic.length; i++) {
            if (pic[i] != "") {
              this.fileList1.push({ url: pic[i] });
            }
          }
          if (msg.video_file != "") {
            this.fileList2.push({ name: "視頻", url: msg.video_file });
          }
          if (msg.content_file != "") {
            this.fileList3.push({ name: "文件", url: msg.content_file });
          }
        }
        let form = this.form;
        form.sectionName = msg.section_name;
        form.intro = msg.intro;
        form.picture_file = msg.picture_file;
        form.video_file = msg.video_file;
        form.content_file = msg.content_file;
        let echoTesting = msg.echoTesting[0];
        if(echoTesting){
          this.questionId = echoTesting.id;
          this.questionName = echoTesting.testing_name;
        }
        let echoUevioms = msg.echoUevioms[0];
        if(echoUevioms){
          this.assessmentId = echoUevioms.id;
          this.assessmentName = echoUevioms.uevioms_name;
        }
        this.time = msg.liveTime;
        this.pageLoading = false
      });
    }
  },
  mounted() {
    $("#pageHead").text("新增章節");
  },
};
</script>

<style scoped>
.btn {
  position: absolute;
  top: 90px;
  right: 45px;
}
.el-upload__tip {
  color: #ff0000;
}
</style>
